module.exports = "<section id='main'>\n\n<h1 class='main-header'>Andyland</h1>\n<p>Some web experiments by that guy you know.</p>\n<!--   <h3 class='pageTitle'>Home</h3>\n  <div class='additionalLinks'>\n    <h4 class='sectionHeader'>Additional Links</h4>\n    <ul class='additionalLinks'>\n        <li><a href='http://andyjmeyers.blogspot.com/'>Blog</a></li>\n        <li><a href='http://jsfiddle.net/user/andyjmeyers/fiddles/'>JS Fiddles</a></li>\n        <li><a href='http://stackoverflow.com/users/1946319/andy-meyers'>Stack Overflow</a></li>\n    </ul>\n  </div> -->\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./app/views/main.html
// module id = 37
// module chunks = 0